module.exports = __webpack_public_path__ + "img/web-seminar.4a84806c.png";